import CookieConsentWrapper from 'app/components/CookieConsent/CookieConsentWrapper'

export default CookieConsentWrapper
